import "./TheLab.module.css";
import Header from "@/reusable_sections/Header";
import ProjectRepository from "./sections/ProjectRepository";
import ProjectLifecycle from "./sections/ProjectLifecycle";
import MemberFeedback from "./sections/MemberFeedback";
import Footer from "@/reusable_sections/Footer";
export default function TheLabPage() {
  return <div>
      <Header />
      <ProjectRepository />
      <ProjectLifecycle />
      <MemberFeedback />
      <Footer />
    </div>;
}